import { useState } from 'react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import type { Draft } from '@/types/api';
import { ChevronUp } from 'lucide-react';
import { parseDraftMetadata } from './draftMetadata';
import { DraftEditDialog } from './DraftEditDialog';

export interface DraftItemProps {
  draft: Draft;
  index: number;
  assignmentId: string;
}

export const DraftItem = ({ draft, index, assignmentId }: DraftItemProps) => {
  const { title, description } = parseDraftMetadata(draft.draftData);
  const displayTitle = title?.trim() || `Draft ${index + 1}`;
  const displayDescription =
    (description && description.trim()) ||
    draft.draftData?.trim() ||
    'No description available.';
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Collapsible className='rounded-md border bg-muted/30'>
      <CollapsibleTrigger className='group flex w-full items-center justify-between px-3 py-2 text-left text-sm font-medium transition hover:bg-muted/60'>
        <div>
          <p>{displayTitle}</p>
        </div>
        <ChevronUp className='size-4 shrink-0 transition group-data-[state=open]:rotate-180' />
      </CollapsibleTrigger>
      <CollapsibleContent className='px-3 pb-3 text-left'>
        <div className='mt-2'>
          <Button
            type='button'
            size='sm'
            variant='outline'
            className='float-right ml-3 mb-2'
            onClick={() => setIsDialogOpen(true)}
          >
            Edit
          </Button>
          <p className='whitespace-pre-wrap text-sm text-muted-foreground'>
            {displayDescription}
          </p>
          <div className='clear-both' />
        </div>
      </CollapsibleContent>
      <DraftEditDialog
        draft={draft}
        assignmentId={assignmentId}
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </Collapsible>
  );
};
